export default {
  id: 'bayhive',
  application: 'bayhive',
  productName: 'BayHive',
  logos: {
    light: new URL('../../../../../img/bayhive-lockup-color.svg', import.meta.url).href,
    dark: new URL('../../../../../img/bayhive-lockup-white-yellow.svg', import.meta.url).href,
    iconLight: new URL('../../../../../img/bayhive-sms-icon.svg', import.meta.url).href,
    iconDark: new URL('../../../../../img/bayhive-sms-icon-white-yellow.svg', import.meta.url).href,
  },
  pdf: {
    text: '#211b34',
    muted: '#665f78',
    body: '#464056',
    border: '#ded7ef',
    rowBorder: '#ebe7f1',
    header: '#f3eff8',
    accent: '#ded7ef',
    warningText: '#b45309',
    font: 'helvetica',
    logo: null,
  },
};
